import ConfirmDialog from '../../../../components/dialogs/confirm-dialog';

type MarkOverwriteProps = {
	isOpen: boolean
	toggle: () => void
	overwriteMarks: () => void
};

export const MarkOverwritePrompt = ({
	isOpen,
	toggle,
	overwriteMarks,
}: MarkOverwriteProps) => {

	return (
		<ConfirmDialog
			isOpen={isOpen}
			title={"Overwrite marks"}
			description={"Are you sure you want to import marks from this chart? This will overwrite any marks you have already made."}
			acceptText="YES"
			rejectText="NO"
			toggle={toggle}
			onSave={(value) => {
				value ? overwriteMarks() : toggle();
			}}
		/>
	);
}
